import { faAward, faCheck, faLongArrowAltLeft, faLongArrowAltRight } from "@fortawesome/free-solid-svg-icons";
import CommentSection from 'app/components/layouts/Comments/CommentSection';
import RightContent from 'app/components/layouts/MenuRight/RightContent';
import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import { updateAppName, convertStyleToObject } from "app/utils/string";
import GoogleAdsense from 'app/components/layouts/Ads/GoogleAdsense';
import DisableCopy from 'app/components/layouts/DisableCopy';
import { stickyNavigator } from 'app/utils/stickyNavigator';
import React, { useEffect, useState, useMemo } from 'react';
import { NextSeo, ArticleJsonLd } from 'next-seo';
import Title from 'app/components/layouts/Title';
import Image from 'app/components/layouts/Image';
import { useTranslation } from 'next-i18next';
import { useRouter } from "next/router";
import parse from "html-react-parser";
import { Test } from 'types/test';
import Link from 'next/link';
import env from '.env.json';
import './styles.css';

import dynamic from "next/dynamic";
const ModalZoomImage = dynamic(() => import("app/components/layouts/Modals/ModalZoomImage"), { ssr: false });

export default function Detail({ blog, typePage = '' }) {
  const router = useRouter();
  const { t } = useTranslation();
  const [visible, setVisible] = useState('hiden');
  const [image, setImage] = useState<HTMLImageElement>();

  useEffect(() => {
    setNavigator();
    return () => { };
  }, [blog]);

  const setNavigator = () => {
    stickyNavigator({
      stickyId: '#sticky-navigator',
      wrapselector: '#body_content',
      targetselector: "h2,h3"
    });
    document.querySelector("img")?.setAttribute("srcset", "");
  };

  const transformContent = useMemo(() => {
    if (!blog?.content) return null;
    const content = updateAppName(blog?.content);

    return parse(content, {
      replace: (domNode: any) => {
        if (domNode.name === "img") {
          const { src, alt, style } = domNode.attribs;
          const newSrc = `${env.URL_APP_FILE || env.URL_API}/${src}`;
          const newStyle = convertStyleToObject(style);

          return (
            <Image
              src={newSrc}
              alt={alt || blog.title}
              width={600}
              height={400}
              style={{
                ...newStyle,
                width: newStyle?.width || 600,
                height: "auto",
                maxWidth: "100%",
              }}
              loading="lazy"
            />
          );
        }
      },
    });
  }, [blog?.content]);

  const getListTests = () => {
    if (blog.tests && blog.tests.length) {
      const testList = blog.tests.map((test: Test, index: number) => {
        return (
          <Link className="tests" key={index} href={`/tests/detail/${test.slug}`}>
            <p className="text-info text-size-md">
              <FontAwesomeIcon className="text-warning mr-2" icon={faCheck} />
              {test?.title[router.locale ?? 'vi']}
            </p>
          </Link>
        );
      });
      return (
        <div className="list-test mt-2">
          <h2 className="mb-4 text-size-2xl font-weight-bold" style={{ color: '#169179' }}>
            {`📝 ${t('commons.practice')} ${blog.title}`}
          </h2>
          {testList}
        </div>
      );
    }

    return <></>;
  };

  if (!blog) return <></>;
  return (
    <section id="blog" className="box-card-area">
      <NextSeo
        title={blog.title}
        description={blog.description}
        additionalMetaTags={[{
          name: 'keywords',
          content: blog.keywords
        }]}
      />
      <ArticleJsonLd
        type="Article"
        url={`${env.ROOT_URL}${router.asPath}`}
        title={blog.title}
        images={[`${env.URL_APP_FILE || env.URL_API}/storage/${blog.image}`]}
        datePublished={blog.created_at}
        dateModified={blog.updated_at}
        authorName={env.APP_NAME}
        publisherName={env.APP_NAME}
        publisherLogo={`${env.ROOT_URL}/images/commons/logos/logo.webp`}
        description={blog.description}
      />
      <ModalZoomImage
        image={image}
        setImage={setImage}
      />
      <div id="navigator" className={visible}>
        <label className="menu text-info">{t('commons.menu')}</label>
        <FontAwesomeIcon
          style={{ fontSize: 20 }}
          onClick={() => setVisible(visible == 'show' ? 'hiden' : 'show')}
          className="cursor-pointer float-right fas text-info"
          icon={visible == 'hiden' ? faLongArrowAltRight : faLongArrowAltLeft}
        />
        <div className="border-menu"></div>
        <div id="sticky-navigator"></div>
      </div>
      <DisableCopy>
        <div className="container-md">
          <div className="d-flex">
            <main className="box-news-area">
              <div className='content_inner'>
                <Title title={blog.title} />
                <div className="mt-4">
                  {typePage !== 'grammar' && blog.image &&
                    <Image
                      id="image-top"
                      alt={blog.title}
                      src={`${env.URL_APP_FILE || env.URL_API}/storage/${blog.image}`}
                      width={1000}
                      height={500}
                      className="cursor-pointer"
                      style={{ width: "100%", height: "auto" }}
                      onClick={(e) => setImage(e.target as HTMLImageElement)}
                    />
                  }
                  {blog.description &&
                    <p className="description mt-3">
                      <FontAwesomeIcon className="text-warning mr-2" icon={faAward} />
                      <i>{blog?.description}</i>
                    </p>
                  }

                  <div id="body_content">
                    <GoogleAdsense width="100%" dataSlot="7482232136" />
                    <div>{transformContent}</div>
                    <GoogleAdsense width="100%" dataSlot="7482232136" />
                    {typePage === 'grammar' &&
                      getListTests()
                    }
                  </div>
                </div>
                <CommentSection roomId={`blog-id-${blog.id}`} />
              </div>
            </main>
            <RightContent />
          </div>
        </div>
      </DisableCopy>
    </section>
  );
}
